import { render, staticRenderFns } from "./TreatmentList.vue?vue&type=template&id=c9c1a716&scoped=true&"
import script from "./TreatmentList.vue?vue&type=script&lang=js&"
export * from "./TreatmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c1a716",
  null
  
)

export default component.exports